export const SHORTCUT_CONTAINER_TEST_ID =
	'command-palette.ui.modal.body.command-shortcut-container';
export const CHEVRON_CONTAINER_TEST_ID = 'command-palette.ui.modal.body.command-chevron-container';
